import { render, staticRenderFns } from "./PopupCropsForm.vue?vue&type=template&id=b867df52&"
import script from "./PopupCropsForm.vue?vue&type=script&lang=js&"
export * from "./PopupCropsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports